import { PamStatus } from '../constants';
import type { PamNotification, PamStateData } from '../types';

const TWO_WEEKS_MS = 1000 * 60 * 60 * 24 * 7 * 2;

type StatusState = Pick<PamNotification, 'dismissed' | 'wasRecentChange'>;

export class PamNotificationService {
  private timeMs(date: string | undefined) {
    return date ? new Date(date).getTime() : 0;
  }

  private wasRecent(dateMs: number) {
    return Date.now() - dateMs < TWO_WEEKS_MS;
  }

  private formatStatusDates(config: PamStateData, status: PamStatus.ENABLED | PamStatus.DISABLED): StatusState {
    const { inherited, user, org, app } = config;

    const userDismissed = status === PamStatus.ENABLED ? user?.dismissedEnabled : user?.dismissedDisabled;
    const userDismissedMs = this.timeMs(userDismissed);

    const date = inherited ? org?.[status] : app?.[status] || org?.[status];
    const dateMs = this.timeMs(date);

    const dismissed = !!(userDismissed && userDismissedMs >= dateMs);
    const wasRecentChange = this.wasRecent(dateMs);
    return { dismissed, wasRecentChange };
  }

  getPamNotification(config: PamStateData): PamNotification {
    const { pamEnabled, inherited, app, org } = config;
    const isNew = pamEnabled === false && !app?.disabled && !org?.disabled;
    const currentStatus = pamEnabled ? PamStatus.ENABLED : PamStatus.DISABLED;
    const { dismissed, wasRecentChange } = this.formatStatusDates(config, currentStatus);
    const status = isNew ? PamStatus.NEW : currentStatus;
    return { dismissed, wasRecentChange, status, inherited: !!inherited };
  }
}
